/*
 * Copyright (c) Nexign, JSC, 2022-2025.
 */
/**
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { pageApi } from '@/main/api/page.api';
import { FAST_ACTIONS } from '@/main/modules/app/Api';

import { TFastActionsResponse } from './types/fastActionsTypes';

export const fastActionsApi = pageApi.injectEndpoints({
    endpoints: (build) => ({
        getFastActions: build.query<TFastActionsResponse, void>({
            query: () => ({
                url: `${FAST_ACTIONS}`,
            }),
        }),
    }),
});

export const { useGetFastActionsQuery } = fastActionsApi;
